import { useUserEntitlements } from '@cfra-nextgen-frontend/shared/src/hooks/useUserEntitlements';
import { TopNavigation } from 'features/topNavigation/TopNavigation';
import { Outlet } from 'react-router-dom';

export const PATHS_WITHOUT_TOP_NAV = [];

export function AuthenticatedRoutesWrapper() {
    const { userEntitlements } = useUserEntitlements();

    return (
        <>
            <TopNavigation userEntitlements={userEntitlements} />
            <Outlet />
        </>
    );
}
